export const COLORS = {
  BUTTON_GREEN_COLOR: '#09f4c7',
  default_white: '#fff',
  juma_theme_clr: '#1A7CFA',
  default_black: '#000',
  table_head: '#F4F9FF',
  theme_light_blue: '#F4F9FF',
};
